import { removeGenericStorageItem, setGenericStorageItem, StorageType } from '../lib/storage';

export const AMEND_TYPES = {
  BOOKING: 'booking',
  OUTFIT: 'outfit',
  PARTY: 'party',
};

export const AMEND_STORAGE_KEYS = {
  /**
   * The current type of amend in storage. This can be any of 'party', 'outfit',
   * 'booking' or undefined. This helps us figure out where the user should be
   * taken when clicking certain amends buttons.
   */
  TYPE: 'Inspiretec.AmendType',
  /**
   * This is currently only used to check if a user has discarded their amends
   * changes. If this isn't set to DISCARD_AMEND, then we know the user didn't
   * fully complete or discard an amend so we show the 'continue amending'
   * modal.
   */
  INTENT: 'Inspiretec.AmendIntent',
};

export const AMEND_INTENTS = {
  DISCARD_AMEND: 'DISCARD_AMEND',
};

export const handleClearStorageOnDiscard = () => {
  // Flag in local storage we have discarded the previous amend.
  setGenericStorageItem(
    AMEND_STORAGE_KEYS.INTENT,
    AMEND_INTENTS.DISCARD_AMEND,
    StorageType.LOCAL_STORAGE,
  );
  // And remove any now unneeded data
  removeGenericStorageItem(AMEND_STORAGE_KEYS.TYPE, StorageType.LOCAL_STORAGE);
};

export default AMEND_TYPES;
